import { render } from "./HolidayManage.vue?vue&type=template&id=2efb3646"
import script from "./HolidayManage.vue?vue&type=script&lang=js"
export * from "./HolidayManage.vue?vue&type=script&lang=js"

import "./HolidayManage.vue?vue&type=style&index=0&id=2efb3646&lang=less"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__